export enum RoleEnum {
    NotSet = 0,
    Client = 1,
    Commercial = 2,
    ADV = 3,
    CoDir = 10,
    SuperAdmin = 11
}
